export const pollContainerStates = {
  LOADING: 0,
  EMPTY: 1,
  LIVE: 2,
  LIST: 3,
  CREATE: 4,
};
